import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ChevronDownIcon = _ref => {
  let {
    width = '8',
    height = '24'
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "8 10 8 5",
    width: width,
    height: height,
    "aria-hidden": true,
    children: /*#__PURE__*/_jsx("g", {
      id: "<Icon>",
      opacity: "0.51",
      children: /*#__PURE__*/_jsx("path", {
        id: "Vector",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.29201 10.2929C8.1052 10.4818 8.00043 10.7368 8.00043 11.0024C8.00043 11.2681 8.1052 11.523 8.29201 11.7119L11.231 14.6769C11.449 14.8919 11.731 14.9989 12.01 14.9989C12.289 14.9989 12.566 14.8919 12.779 14.6769L15.709 11.7219C15.8956 11.5329 16.0002 11.278 16.0002 11.0124C16.0002 10.7469 15.8956 10.492 15.709 10.3029C15.6172 10.2098 15.5077 10.1358 15.387 10.0853C15.2664 10.0347 15.1368 10.0087 15.006 10.0087C14.8752 10.0087 14.7457 10.0347 14.625 10.0853C14.5043 10.1358 14.3948 10.2098 14.303 10.3029L12.005 12.6199L9.69801 10.2929C9.60597 10.2001 9.49646 10.1264 9.3758 10.0762C9.25514 10.0259 9.12572 10 8.99501 10C8.86429 10 8.73487 10.0259 8.61421 10.0762C8.49355 10.1264 8.38404 10.2001 8.29201 10.2929Z",
        fill: "currentColor"
      })
    })
  });
};